import { 
  ProductTabNameExtension, 
  ProductTabSortOrder, 
  ProductType 
} from "../../../utils/data/enum";

// export interface ProductOption {
//   product: string,
//   sortOrder: number,
// }

export const isProductSectionAvailable = (
  availableProducts: string[],
  fileNameNumber?: string,
  agencyId?: string,
  agencyLocationId?: string,
  stateAbbr?: string
) => {
  let isAvailable = false;
  if (
    fileNameNumber &&
    agencyId &&
    agencyLocationId &&
    stateAbbr &&
    availableProducts.length > 0
  ) {
    isAvailable = true;
  }

  return isAvailable;
};

export const getProductTabSortOrder = (productTypeCode: string) => {
  let sortOrder = 0;
  switch (productTypeCode) {
    case ProductType.Aal:
      sortOrder = ProductTabSortOrder.Aal;
      break;
    case ProductType.Cpl:
      sortOrder = ProductTabSortOrder.Cpl;
      break;
    case ProductType.Jacket:
      sortOrder = ProductTabSortOrder.Jacket;
      break;
    case ProductType.StandaloneEndorsement:
      sortOrder = ProductTabSortOrder.StandaloneEndorsement;
      break;
    case ProductType.TitleSearch:
      sortOrder = ProductTabSortOrder.TitleSearch;
      break;      
    case ProductTabNameExtension.PolicyUpload:
      sortOrder = ProductTabSortOrder.PolicyUpload;
      break;
    default:
      sortOrder = 0;
      break;                      
  }

  return sortOrder;
}